document.addEventListener('DOMContentLoaded', function () {
  var popup = document.createElement('div');
  popup.id = 'prop65-popup';
  popup.innerHTML =
    '<div class="prop65-overlay"></div>' +
    '<div class="prop65-modal">' +
    '<button class="prop65-close"> Close <span>&times;</span> </button>' +
    '<div class="prop65-header">' +
    '<h4 class="custom_h4_prop65 csw-heading text-center h4">WARNING: Cancer and Reproductive Harm</h4>' +
    '</div>' +
    '<a href="https://operabeds.com/en-us/pages/proposition-65" target="_blank">Learn more about Prop 65</a>' +
    '</div>';
  document.body.appendChild(popup);

  document.addEventListener('click', function (event) {
    var prop65Trigger = event.target.closest('.prop-65-pop-up');
    if (prop65Trigger) {
      if (prop65Trigger.tagName !== 'INPUT' && prop65Trigger.type !== 'submit') {
        event.preventDefault();
      }
      popup.classList.add('show');
    }
  });

  popup.addEventListener('click', function (event) {
    if (event.target.classList.contains('prop65-close') || event.target.classList.contains('prop65-overlay')) {
      popup.classList.remove('show');
    }
  });

  var style = document.createElement('style');
  style.innerHTML =
    '.prop-65-pop-up, .prop65-trigger { color: #96917d; text-decoration: underline; }' +
    '.custom_h4_prop65 { margin-bottom: 1rem !important; font-size: 20px; }' +
    '#prop65-popup { position: fixed; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #000000a6; z-index: 9999; opacity: 0; transform: scale(0.9); transition: opacity .2s; pointer-events: none; }' +
    '#prop65-popup.show { opacity: 1; transform: scale(1); pointer-events: auto; }' +
    '.prop65-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); }' +
    '.prop65-modal { background: #ffffff; padding: 50px; width: 90%; max-width: 550px; text-align: center; border-radius: 8px; box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15); position: relative; font-family: inherit; }' +
    '.prop65-close { position: absolute; top: 8px; right: 10px; background: none; border: none; font-size: 12px !important; cursor: pointer; color: #333; display: flex; align-items: center; gap: 4px; }' +
    '.prop65-close span { font-size: 18px !important; font-weight: bold; }' +
    '.prop65-header { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #333; margin-bottom: 8px; }' +
    '.prop65-modal a { display: inline-block; margin-top: 5px; color: #96917d; text-decoration: underline; font-size: 14px; transition: color 0.3s ease; }' +
    '.prop65-modal a:hover { color: #96917d; }' +
    '@media (max-width: 600px) { .prop65-modal { width: 95%; max-width: 350px; padding: 40px; } }';
  document.head.appendChild(style);
});